import { useState, useMemo } from "react";
import { NotificationUILayer } from "./NotificationUILayer";
import { useNotifications } from "../../contexts/NotificationContext";
import { useNavigate } from "react-router-dom";

const NotificationMenu = () => {
  const navigate = useNavigate();
  const [activeFilter, setActiveFilter] = useState("all");
  const {
    notifications,
    loading,
    unreadCount,
    markAsRead,
    markAllAsRead,
    isMarkingAsRead,
  } = useNotifications();

  const handleNotificationClick = (notification) => {
    if (!notification.is_read) {
      markAsRead(notification.id);
    }

    if (
      notification.type_of_notification === "care_plan" ||
      notification.type_of_notification === "patient_assigned"
    ) {
      sessionStorage.setItem("_dash", "nurse");

      if (notification?.patient) {
        const { patient } = notification;

        sessionStorage.setItem("_pt_id", patient.id);
        const ccm = Number(patient.ccm);
        const rpm = Number(patient.rpm);
        const patientId = patient.id;

        const targetUrl = `/patient/details/?patient_id=${patientId}&CCM=${ccm}&RPM=${rpm}`;

        // Force a full reload so the page refreshes after navigation
        window.location.assign(targetUrl);
      }
    }
  };

  const handleFilterChange = (filter) => {
    setActiveFilter(filter);
  };

  // Memoize filtered notifications
  const filteredNotifications = useMemo(() => {
    return notifications.filter((notif) => {
      if (activeFilter === "unread") return !notif.is_read;
      if (activeFilter === "read") return notif.is_read;
      return true;
    });
  }, [notifications, activeFilter]);

  return (
    <NotificationUILayer
      notifications={notifications}
      filteredNotifications={filteredNotifications}
      activeFilter={activeFilter}
      loading={loading}
      unreadCount={unreadCount}
      onFilterChange={handleFilterChange}
      onMarkAllAsRead={markAllAsRead}
      onNotificationClick={handleNotificationClick}
    />
  );
};

export default NotificationMenu;
